export default {
  url: '/umbraco/api/toursbypricesapi/tours',
  items: [],
  itemsRemaining: 0,
  itemsCount: 0,
  take: 0,
  totalPages: 1
};